import mapCsConnectionToArray from '../csConnectionToArray';

const mapLinkAccountPage = (data) => {
  const { title, url, cta, bannerText, disclaimer, imageConnection, offer, terms, features } = data;
  const mappedImageConnection = mapCsConnectionToArray(imageConnection)[0];

  return {
    bannerText,
    cta,
    disclaimer,
    features,
    image: {
      src: mappedImageConnection.url
    },
    offer,
    terms,
    title,
    url,
  };
};

export default mapLinkAccountPage;
